import { AnimatePresence } from 'framer-motion';
import React, { createContext, useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { GlobalContext } from 'utilities/GlobalContext';
import { useOnClickOutside } from 'utilities/useOnClickOutside';
import Bolt from './components/Bolt/Bolt';
import PrintModal from './components/Bolt/PrintModal/PrintModal';
import Calendar from './components/Calendar/Calendar';
import DeleteModal from './components/Calendar/Components/DeleteModal/DeleteModal';
import City from './components/City/City';
import Cog from './components/Cog/Cog';
import Dog from './components/Dog/Dog';
import Ear from './components/Ear/Ear';
import Microphone from './components/Microphone/Microphone';
import Pointer from './components/Pointer/Pointer';
import Steps from './components/Steps/Steps';
import './Menu.module.scss';
import Exclamation from './components/Exclamation/Exclamation';

type LocalMouseEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;

type MenuContextTypes = {
    selected: selectedOptions;
    setSelected: React.Dispatch<React.SetStateAction<selectedOptions>>;
    select: (type: selectedOptions) => void;
    menuY: number;
    setMenuPointer: (event: LocalMouseEvent) => void;
    activeLogForDeleteModal?: LogBookEntry;
    setActiveLogForDeleteModal: React.Dispatch<
        React.SetStateAction<undefined | LogBookEntry>
    >;
    printModalIsOpen: boolean;
    setPrintModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MenuContext = createContext({} as MenuContextTypes);

export default function Menu() {
    const { selected, setSelected, menuY, setMenuY } = useContext(
        GlobalContext
    );

    const [activeLogForDeleteModal, setActiveLogForDeleteModal] = useState<
        LogBookEntry | undefined
    >(undefined);

    const [printModalIsOpen, setPrintModalIsOpen] = useState(false);

    function select(type: selectedOptions) {
        setSelected((prev) => (prev === type ? 'initial' : type));
    }

    function setMenuPointer(event: LocalMouseEvent) {
        const item = ((event.target as HTMLImageElement)
            .parentElement as HTMLButtonElement)
            .parentElement as HTMLDivElement;

        setMenuY(item.offsetTop - 1.5);
    }

    const ref = useRef(null);

    const { location } = useHistory();

    useOnClickOutside(
        ref,
        () => setSelected('initial'),
        selected !== 'initial' && location.pathname === '/'
    );

    return (
        <MenuContext.Provider
            value={{
                selected,
                setSelected,
                select,
                menuY,
                setMenuPointer,
                activeLogForDeleteModal,
                setActiveLogForDeleteModal,
                printModalIsOpen,
                setPrintModalIsOpen,
            }}
        >
            <div ref={ref}>
                <div styleName="wrapper">
                    <div styleName="menu">
                        <City />
                        <Steps />
                        <Dog />
                        <Ear />
                        <Bolt />
                        <hr />
                        <Microphone />
                        <Calendar />
                        <Exclamation />
                        <Cog />
                        <Pointer />
                    </div>
                </div>
                <AnimatePresence>
                    {!!activeLogForDeleteModal && <DeleteModal />}
                </AnimatePresence>
                <AnimatePresence>
                    {!!printModalIsOpen && <PrintModal />}
                </AnimatePresence>
            </div>
        </MenuContext.Provider>
    );
}
